<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

function matchheight() {
  $(".product-item .card-information__wrapper .card-information__group").matchHeight();
  // $(".product-item .card .card-product").matchHeight();
 // $(".product-item .card-information__wrapper .card__heading").matchHeight();
 // $(".product-item .card-information__wrapper .card-summary").matchHeight();
  $(".product-item .card-information__wrapper .card-price").matchHeight();
  $("footer .footer-block__column .footer-block__heading").matchHeight();
  $(".custom-service-block .halo-item .policies-text").matchHeight();
  $(".custom-service-block .halo-item .policies-des").matchHeight();
  $(".policies-block .halo-item .policies-text").matchHeight();
  // $("body .brand-tab-block .wrapper-item.has-content").matchHeight();
}

$(window).on("load", function () {    
  matchheight();
});

const timeID = setInterval(matchheight2, 1000);
function matchheight2() {
  //$(".custom-service-block .halo-item").matchHeight();
}
$(window).on("load", function () {    
 matchheight2();
});

$(document).ready(function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    // console.log(links[i].hostname);
    if(links[i].hostname != ""){
      if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
      }
    }
  } 
  $("input[name='contact[phone]']").keypress(function(e) {
    var charCode = e.which ? e.which : event.keyCode;
    if (String.fromCharCode(charCode).match(/[^0-9+]/g)) return !1;
  });

  if(window.location.hash == '#recover'){
    $("html, body").animate({ scrollTop: 130 }, "slow");
  }
  $('.forget-password,.cancel').click(function(){
    $("html, body").animate({ scrollTop: 130 }, "slow");
  });
 
});